import { Component } from '@angular/core';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-economicperformance-help',
  templateUrl: './economicperformance-help.component.html',
  styleUrl: './economicperformance-help.component.scss',
})
export class EconomicperformanceHelpComponent {
  faFilePdf: any = faFilePdf;
}